angular.module('leanlaw').component('tooltip', {
  template: require('./tooltip.component.html'),
  bindings: {
    data: '=',
    placement: '='
  }
});

//   function placement(placement) {
//     if(placement) return placement;

//     return 'right';
//   }